// Trick js for force the browser to disable/enable the willChange on blocks
// This property when enable allow the brower so calculate the movement of the blocks with de gpu and not the cpu
// But this can lead to 'blur' effect on element so we need to disable it
const applyWillChange = () => {
    //const el = document.querySelector('.elements');
    const blocks = [...document.querySelectorAll('.block')];
    blocks.map(block => block.style.willChange = 'transform')
    const paths = [...document.querySelectorAll('path')];
    paths.map(path => path.style.willChange = 'transform')
    return true;
}

const disableWillChange = () => {
    //const el = document.querySelector('.elements');
    const blocks = [...document.querySelectorAll('.block')];
    blocks.map(block => block.style.willChange = 'initial');
    const paths = [...document.querySelectorAll('path')];
    paths.map(path => path.style.willChange = 'initial')
    return true;
}

export {applyWillChange, disableWillChange}
export default {applyWillChange, disableWillChange}

